import { DropdownItemEventTypeInput } from './DropdownItemEventTypeInput';
// import { IMultiSelectOption } from '../../modules/angular-2-dropdown-multiselect-1.0.8';

// export class DropdownItem implements IMultiSelectOption {
export class DropdownItem {
    constructor(
        dropdownItemId: number,
        dropdownGroupId: number,
        name: string,
        itemOrder: number,
        deleted: boolean,
        dropdownItemEventTypeInputArray: DropdownItemEventTypeInput[]
    ) {
        this.id = dropdownItemId;
        this.dropdownItemId = dropdownItemId;
        this.dropdownGroupId = dropdownGroupId;
        this.name = name;
        this.itemOrder = itemOrder;
        this.deleted = deleted;
        this.dropdownItemEventTypeInputArray = dropdownItemEventTypeInputArray;
        this.eventTypeGroupSequenceIdentity = null;
    }
    id: number;
    dropdownItemId: number;
    dropdownGroupId: number;
    name: string;
    itemOrder: number;
    deleted: boolean;
    dropdownItemEventTypeInputArray: DropdownItemEventTypeInput[];
    eventTypeGroupSequenceIdentity: string | null; // View model
}
